import React from "react";
import SearchBox from "../../../components/SearchBox/SearchBox";
import styles from "./Banner.module.css";

export default function Banner(props) {
  const { placeholder, onSearch } = props;
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.heroText}>
          <h1>
            <span className={styles.accent}>Frequently</span>
            <span className={styles.accent2}>
              Asked <br />
              Questions
            </span>
          </h1>
          <p>
            Find answers to common questions about IMPARC membership,
            mentorship, and services
          </p>
          <div className={styles.heroActions}>
            <SearchBox placeholder={placeholder} onSearch={onSearch} />
          </div>
        </div>
      </div>
    </section>
  );
}
